import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=599727d0&scoped=true&functional=true&"
import script from "./Score.vue?vue&type=script&lang=ts&"
export * from "./Score.vue?vue&type=script&lang=ts&"
import style0 from "./Score.vue?vue&type=style&index=0&id=599727d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "599727d0",
  null
  
)

export default component.exports